import { useEffect, useMemo, useState, useSyncExternalStore } from "react";
import { SESSION_UPDATED_EVENT } from "../utils/accountLinks";
import { getStoredUser } from "../utils/impersonation";
import { localToday } from "../utils/localDate";
import { getReportDateAccess, REPORT_DATE_ACCESS, ROLE_UI_PERMISSIONS_EVENT } from "../utils/roleUiPermissions";

const subscribe = (notify) => {
  window.addEventListener(ROLE_UI_PERMISSIONS_EVENT, notify);
  window.addEventListener("storage", notify);
  window.addEventListener(SESSION_UPDATED_EVENT, notify);
  return () => {
    window.removeEventListener(ROLE_UI_PERMISSIONS_EVENT, notify);
    window.removeEventListener("storage", notify);
    window.removeEventListener(SESSION_UPDATED_EVENT, notify);
  };
};
const snapshot = () => getReportDateAccess(getStoredUser());

export function useReportDateAccess() {
  const access = useSyncExternalStore(subscribe, snapshot, snapshot);
  const [today, setToday] = useState(localToday);
  useEffect(() => {
    const update = () => setToday(localToday());
    const timer = window.setInterval(update, 1000);
    window.addEventListener("focus", update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", update);
    };
  }, []);
  return { todayOnly: access === REPORT_DATE_ACCESS.TODAY_ONLY, today };
}

// Clamp during render, before any report effect or export can use the value.
export function useReportDateState(initialValue, kind = "date") {
  const [value, setValue] = useState(initialValue);
  const { todayOnly, today } = useReportDateAccess();
  const restricted = useMemo(() => {
    if (kind === "month") return today.slice(0, 7);
    if (kind === "mode") return "day";
    if (kind === "filters") return { ...value, fromDate: today, toDate: today };
    return today;
  }, [kind, today, value]);
  return [todayOnly ? restricted : value, setValue];
}
